import {PlayersStatisticsTableRowSummaryRowDomainModel} from "./players-statistics.table.row.summary-row.domain-model";
import {PlayersStatisticsTableRowViewModel} from "../players-statistics.table.row.view-model";

export class PlayersStatisticsTableRowSummaryRowViewModel extends PlayersStatisticsTableRowViewModel {
  domainModel: PlayersStatisticsTableRowSummaryRowDomainModel;

  get title(): Number {
    return this.domainModel.title;
  }
}
